App.factory('AppointmentCategory', ['restmod', restmod => {
  return restmod.model('/appointment_categories').mix({
    $extend: {
      Model: {
        $loadAll: function(params = {}) {
          const model = this;

          return new Promise(function(resolve, reject) {
            let collection = [];

            const fetcher = function(page) {
              req = model.$search(_.merge(params, { page, per_page: 50 }))
              req.$then(() => {
                if (!req.$response.data.code) {
                  if (_.isEqual(req.$response.data.error, ["No appointment categories yet."])) {
                    resolve([])
                  } else {
                    reject(req.response)
                  }
                  return
                }

                collection = _.uniqBy(collection.concat(req.$response.data.data), 'id')

                if (collection.length < req.$response.data.count) {
                  fetcher(page + 1)
                } else {
                  resolve(collection)
                }
              })
            }

            fetcher(1)
          })
        }
      }
    }
  })
}])
